const state = {
  draftID: null,
  AllWidgets: [],
  AllAllWidgets: [],
  widgetStateData: {}
};

export default state;
